import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { toggleAnimation } from "src/app/shared/animations";

@Component({
  templateUrl: "./customer-details.component.html",
  standalone: false,
  animations: [toggleAnimation],
})
export class CustomerDetailsComponent implements OnInit {
  public id!: number;
  apiKey!: string;
  isLoading = false;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id = Number.parseInt(params["id"]);
    });
    this.isLoading = true;
  }

  setApiKey(key: string) {
    this.apiKey = key;
    this.isLoading = false;
  }
}
